var render = function render(){var _vm=this,_c=_vm._self._c;return _c('region-page',{key:_vm.activeYear,attrs:{"guest":_vm.guest,"active-year":_vm.activeYear,"region":_vm.region,"municipality-name":_vm.municipalityName,"searched":_vm.searched}})
}
var staticRenderFns = []

export { render, staticRenderFns }